(() => {
  'use strict';

  /* PN8A_PUBLIC_EVENT_ADMIN */

  const root =
    document.querySelector(
      '[data-pne-page]'
    );

  if (!root) return;


  const page =
    document.documentElement;

  const grid =
    root.querySelector(
      '[data-pne-grid]'
    );


  let adminRows = [];

  /* PN8A_EVENT_PARTICIPANTS */
  let registrationRows = [];

  let ui = null;
  let modal = null;
  let observer = null;


  function escapeHTML(value) {

    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  function isAdminMode() {

    return (
      page.dataset.pnIsAdmin === 'true'
      &&
      page.dataset.pnAdminView === 'admin'
    );

  }


  function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB.request(
      `rpc/${name}`,
      '',
      {
        method:'POST',
        body
      }
    );

  }


  function request(
    table,
    query
  ) {

    return window.PeerNestDB.request(
      table,
      query
    );

  }


  function localInputDate(value) {

    if (!value) {
      return '';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    const local =
      new Date(
        date.getTime()
        -
        date.getTimezoneOffset()
        * 60000
      );


    return local
      .toISOString()
      .slice(0,16);

  }


  function prettyDate(value) {

    if (!value) {
      return 'Date TBA';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return 'Date TBA';
    }


    return date.toLocaleString(
      'en-IN',
      {
        dateStyle:'medium',
        timeStyle:'short'
      }
    );

  }


  /* PN_MANAGE_EVENTS_RICH_TEAM_V1 */

  function pnRichEventLinesValue(
    value,
    type
  ) {

    if (!Array.isArray(value)) {
      return '';
    }


    if (type === 'rules') {

      return value
        .map(
          item => {

            if (
              typeof item === 'string'
            ) {
              return item;
            }


            return (
              item?.text ||
              item?.title ||
              item?.description ||
              ''
            );

          }
        )
        .filter(Boolean)
        .join('\n');

    }


    if (type === 'incentives') {

      return value
        .map(
          item => {

            if (
              typeof item === 'string'
            ) {
              return item;
            }


            return [
              item?.title || '',
              item?.reward || '',
              item?.description || ''
            ]
              .join(' | ')
              .replace(
                /\s*\|\s*\|\s*$/,
                ''
              );

          }
        )
        .filter(Boolean)
        .join('\n');

    }


    return value
      .map(
        item => {

          if (
            typeof item === 'string'
          ) {
            return item;
          }


          return [
            item?.title ||
            item?.stage ||
            '',
            item?.description ||
            ''
          ]
            .join(' | ')
            .replace(
              /\s*\|\s*$/,
              ''
            );

        }
      )
      .filter(Boolean)
      .join('\n');

  }


  function pnParseEventLines(
    value,
    type
  ) {

    const lines =
      String(
        value || ''
      )
        .split(/\r?\n/)
        .map(
          line =>
            line.trim()
        )
        .filter(Boolean);


    if (type === 'rules') {
      return lines;
    }


    if (type === 'incentives') {

      return lines.map(
        line => {

          const parts =
            line
              .split('|')
              .map(
                part =>
                  part.trim()
              );


          return {
            title:
              parts[0] || '',

            reward:
              parts[1] || '',

            description:
              parts
                .slice(2)
                .join(' | ')
          };

        }
      );

    }


    return lines.map(
      line => {

        const parts =
          line
            .split('|')
            .map(
              part =>
                part.trim()
            );


        return {
          title:
            parts[0] || '',

          description:
            parts
              .slice(1)
              .join(' | ')
        };

      }
    );

  }


  /* PN8A_EVENT_FORM_BEHAVIOUR */

  function hydrateEventForm(
    form
  ) {

    if (!form) {
      return;
    }


    const mode =
      form.elements.mode;


    const meeting =
      form.elements.meeting_url;


    const venue =
      form.elements.venue;


    const meetingField =
      form.querySelector(
        '[data-pn8ea-meeting-field]'
      );


    const venueField =
      form.querySelector(
        '[data-pn8ea-venue-field]'
      );


    const paid =
      form.elements.is_paid;


    const price =
      form.elements.price;


    const cover =
      form.elements.cover_image_file;


    const preview =
      form.querySelector(
        '[data-pn8ea-cover-preview]'
      );


    const placeholder =
      form.querySelector(
        '[data-pn8ea-cover-placeholder]'
      );


    const customTypeField =
      form.querySelector(
        '[data-pn8ea-custom-type-field]'
      );


    const customTypeInput =
      form.elements
        .custom_event_type;


    function syncEventType() {

      const isOther =
        form.elements
          .event_type
          ?.value ===
        'other';


      if (customTypeField) {

        customTypeField.hidden =
          !isOther;

      }


      if (customTypeInput) {

        customTypeInput.disabled =
          !isOther;


        customTypeInput.required =
          isOther;

      }

    }


    function syncChoiceGroup(
      name
    ) {

      const hidden =
        form.elements[name];


      form
        .querySelectorAll(
          `[data-pn8ea-choice="${name}"]`
        )
        .forEach(
          button => {

            button.classList.toggle(
              'is-selected',
              button.dataset.value ===
                hidden?.value
            );

          }
        );

    }


    function syncMode() {

      const current =
        mode?.value ||
        'online';


      const showMeeting =
        current === 'online'
        ||
        current === 'hybrid';


      const showVenue =
        current === 'offline'
        ||
        current === 'hybrid';


      if (meetingField) {

        meetingField.hidden =
          !showMeeting;

      }


      if (meeting) {

        meeting.disabled =
          !showMeeting;

      }


      if (venueField) {

        venueField.hidden =
          !showVenue;

      }


      if (venue) {

        venue.disabled =
          !showVenue;

      }


      syncChoiceGroup(
        'mode'
      );

    }


    function syncPaid() {

      const enabled =
        !!paid?.checked;


      if (price) {

        price.disabled =
          !enabled;


        if (!enabled) {

          price.value =
            '0';

        }

      }


      form.classList.toggle(
        'is-paid',
        enabled
      );

    }


    function updateCoverPreview() {

      const file =
        cover?.files?.[0];


      if (!file) {
        return;
      }


      const url =
        URL.createObjectURL(
          file
        );


      if (preview) {

        preview.src =
          url;

        preview.hidden =
          false;

      }


      if (placeholder) {

        placeholder.hidden =
          true;

      }

    }


    form
      .querySelectorAll(
        '[data-pn8ea-choice]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            () => {

              const name =
                button.dataset
                  .pn8eaChoice;


              const value =
                button.dataset
                  .value;


              const hidden =
                form.elements[name];


              if (!hidden) {
                return;
              }


              hidden.value =
                value;


              syncChoiceGroup(
                name
              );


              hidden.dispatchEvent(
                new Event(
                  'change',
                  {
                    bubbles:true
                  }
                )
              );

            }
          );

        }
      );


    form.elements
      .event_type
      ?.addEventListener(
        'change',
        syncEventType
      );


    mode?.addEventListener(
      'change',
      syncMode
    );


    paid?.addEventListener(
      'change',
      syncPaid
    );


    cover?.addEventListener(
      'change',
      updateCoverPreview
    );


    [
      'event_type',
      'mode',
      'status'
    ]
      .forEach(
        syncChoiceGroup
      );


    syncEventType();

    syncMode();

    syncPaid();

  }



  function registrationsForEvent(
    eventId
  ) {

    return registrationRows.filter(
      row =>
        row.event_id ===
        eventId
    );

  }


  function activeRegistrations(
    eventId
  ) {

    return registrationsForEvent(
      eventId
    )
      .filter(
        row =>
          [
            'reserved',
            'payment_pending',
            'confirmed',
            'attended'
          ].includes(
            row.status
          )
      );

  }


  function participantCount(
    eventId
  ) {

    return activeRegistrations(
      eventId
    ).length;

  }


  function spotsLeft(
    row
  ) {

    if (
      row.capacity === null
      ||
      row.capacity === undefined
    ) {
      return null;
    }


    return Math.max(
      Number(row.capacity)
      -
      participantCount(
        row.id
      ),
      0
    );

  }


  async function loadAdminEvents() {

    if (
      !isAdminMode()
      ||
      !window.PeerNestDB
    ) {
      return;
    }


    try {

      const [
        eventsResult,
        registrationsResult
      ] =
        await Promise.all([

          request(
            'events',
            'select=*&order=starts_at.asc&limit=250'
          ),

          request(
            'event_registrations',
            'select=id,event_id,user_id,status,ticket_code,created_at,confirmed_at,cancelled_at&order=created_at.desc&limit=2000'
          )

        ]);


      adminRows =
        Array.isArray(
          eventsResult
        )
          ? eventsResult
          : [];


      registrationRows =
        Array.isArray(
          registrationsResult
        )
          ? registrationsResult
          : [];


      decorateCards();

      updateCount();

    }
    catch (error) {

      console.error(
        '[PeerNest Event Admin]',
        error
      );

    }

  }


  function updateCount() {

    const node =
      ui?.querySelector(
        '[data-pn8ea-total]'
      );


    if (node) {

      node.textContent =
        String(
          adminRows.length
        );

    }

  }


  function ensureUI() {

    if (ui) {
      return;
    }


    const heading =
      root.querySelector(
        '.pne-heading'
      );


    if (!heading) {
      return;
    }


    ui =
      document.createElement(
        'div'
      );


    ui.className =
      'pn8ea-actions';


    ui.dataset
      .pn8eaActions = '';


    ui.innerHTML = `
      <button
        type="button"
        class="pn8ea-manage"
        data-pn8ea-manage
      >
        Manage Events
        <span data-pn8ea-total>0</span>
      </button>

      <button
        type="button"
        class="pn8ea-add"
        data-pn8ea-add
      >
        + Add Event
      </button>
    `;


    const count =
      heading.querySelector(
        '.pne-count'
      );


    if (count) {

      heading.insertBefore(
        ui,
        count
      );

    }
    else {

      heading.appendChild(
        ui
      );

    }


    ui
      .querySelector(
        '[data-pn8ea-add]'
      )
      .addEventListener(
        'click',
        () => openEditor()
      );


    ui
      .querySelector(
        '[data-pn8ea-manage]'
      )
      .addEventListener(
        'click',
        openManager
      );

  }


  function removeCardAdmin(
    card
  ) {

    card
      .querySelectorAll(
        '[data-pn8ea-card-admin]'
      )
      .forEach(
        node => node.remove()
      );

  }


  function decorateCards() {

    if (!grid) {
      return;
    }


    grid
      .querySelectorAll(
        '[data-pn8e-event]'
      )
      .forEach(
        card => {

          const existing =
            card.querySelector(
              '[data-pn8ea-card-admin]'
            );


          if (!isAdminMode()) {

            existing?.remove();

            return;

          }


          /*
           * Important:
           * Do NOT remove + recreate an existing admin strip.
           *
           * The grid is watched by MutationObserver.
           * Replacing this node on every observer callback
           * creates an infinite mutation loop and freezes
           * the Events page.
           */
          if (existing) {
            return;
          }


          const id =
            card.dataset
              .pn8eEvent;


          const row =
            adminRows.find(
              event =>
                event.id === id
            );


          if (!row) {
            return;
          }


          const controls =
            document.createElement(
              'div'
            );


          controls.className =
            'pn8ea-card-admin';


          controls.dataset
            .pn8eaCardAdmin = '';


          controls.innerHTML = `
            <div class="pn8ea-card-admin__meta">

              <span>
                ADMIN ·
                ${escapeHTML(
                  row.status
                )}
              </span>

              <small>
                ${participantCount(
                  row.id
                )}
                registered

                ${
                  spotsLeft(row) !== null
                    ? ` · ${spotsLeft(row)} spots left`
                    : ''
                }
              </small>

            </div>


            <div class="pn8ea-card-admin__actions">

              <button
                type="button"
                data-pn8ea-edit="${escapeHTML(
                  row.id
                )}"
              >
                Edit ✎
              </button>


              <button
                type="button"
                data-pn8ea-participants="${escapeHTML(
                  row.id
                )}"
              >
                Participants
                ${participantCount(
                  row.id
                )}
              </button>

            </div>
          `;


          const contentTarget =
            card.querySelector(
              '.pn8e-content'
            ) ||
            card.querySelector(
              '.pn8e-details'
            ) ||
            card.querySelector(
              '.pn8e-info'
            ) ||
            card.querySelector(
              '.pn8e-copy'
            ) ||
            card.querySelector(
              '.pn8e-body'
            ) ||
            card.querySelector(
              '.pn8e-card__content'
            ) ||
            card;


          const primaryAction =
            contentTarget.querySelector(
              'a[href], button'
            );


          if (
            primaryAction &&
            primaryAction.parentNode === contentTarget
          ) {

            primaryAction.insertAdjacentElement(
              'afterend',
              controls
            );

          }
          else {

            contentTarget.append(
              controls
            );

          }

        }
      );

  }


  function statusButtons(
    row
  ) {

    return [
      'draft',
      'published',
      'completed',
      'cancelled'
    ]
      .filter(
        status =>
          status !==
          row.status
      )
      .map(
        status => `
          <button
            type="button"
            data-pn8ea-status="${escapeHTML(
              row.id
            )}"
            data-next-status="${status}"
          >
            ${
              status === 'published'
                ? 'Publish'
                : status === 'draft'
                  ? 'Move to Draft'
                  : status === 'completed'
                    ? 'Complete'
                    : 'Cancel'
            }
          </button>
        `
      )
      .join('');

  }


  function managerRow(row) {

    return `
      <article class="pn8ea-manager-row">

        <div>

          <div class="pn8ea-manager-row__top">

            <span
              class="pn8ea-status"
              data-status="${escapeHTML(
                row.status
              )}"
            >
              ${escapeHTML(
                row.status
              )}
            </span>

            <span>
              ${escapeHTML(
                row.event_type === 'other'
                  ? (
                      row.custom_event_type ||
                      'Other'
                    )
                  : row.event_type
              )}
              ·
              ${escapeHTML(
                row.mode
              )}
            </span>

          </div>


          <h4>
            ${escapeHTML(
              row.title
            )}
          </h4>


          <p>
            ${escapeHTML(
              prettyDate(
                row.starts_at
              )
            )}
          </p>

        </div>


        <div class="pn8ea-manager-row__actions">

          <button
            type="button"
            class="pn8ea-primary-small"
            data-pn8ea-edit="${escapeHTML(
              row.id
            )}"
          >
            Edit
          </button>


          <button
            type="button"
            data-pn8ea-participants="${escapeHTML(
              row.id
            )}"
          >
            Participants
            ${participantCount(
              row.id
            )}
          </button>

          ${statusButtons(row)}

        </div>

      </article>
    `;

  }


  function ensureModal() {

    if (modal) {
      return modal;
    }


    modal =
      document.createElement(
        'div'
      );


    modal.className =
      'pn8ea-modal';


    modal.dataset
      .pn8eaModal = '';


    modal.hidden =
      true;


    modal.innerHTML = `
      <button
        type="button"
        class="pn8ea-backdrop"
        data-pn8ea-close
        aria-label="Close event editor"
      ></button>

      <aside
        class="pn8ea-drawer"
        role="dialog"
        aria-modal="true"
        aria-label="PeerNest Event Manager"
      >
        <div data-pn8ea-drawer-content></div>
      </aside>
    `;


    document.body
      .appendChild(
        modal
      );


    return modal;

  }


  function showModal(
    content
  ) {

    const shell =
      ensureModal();


    const target =
      shell.querySelector(
        '[data-pn8ea-drawer-content]'
      );


    target.innerHTML =
      content;


    shell.hidden =
      false;


    requestAnimationFrame(
      () => {

        shell.classList.add(
          'is-open'
        );

      }
    );


    document.documentElement
      .classList.add(
        'pn8ea-lock'
      );

  }


  function closeModal() {

    if (!modal) {
      return;
    }


    modal.classList.remove(
      'is-open'
    );


    document.documentElement
      .classList.remove(
        'pn8ea-lock'
      );


    window.setTimeout(
      () => {

        if (modal) {
          modal.hidden = true;
        }

      },
      200
    );

  }


  function openManager() {

    showModal(`
      <div class="pn8ea-drawer-head">

        <div>
          <small>
            ADMIN · EVENTS
          </small>

          <h2>
            Event Manager
          </h2>

          <p>
            Create, edit and publish PeerNest events
            directly from the public Events page.
          </p>
        </div>

        <button
          type="button"
          data-pn8ea-close
        >
          ×
        </button>

      </div>


      <button
        type="button"
        class="pn8ea-add pn8ea-add--wide"
        data-pn8ea-add-inside
      >
        + Add Event
      </button>


      <div class="pn8ea-manager-list">

        ${
          adminRows.length
            ? adminRows
                .map(
                  managerRow
                )
                .join('')
            : `
              <div class="pn8ea-empty">
                No events yet.
                Create PeerNest's first event.
              </div>
            `
        }

      </div>
    `);

  }


  function editorForm(
    row = {}
  ) {

    const editing =
      !!row.id;


    const selectedType =
      row.event_type ||
      'workshop';


    const selectedMode =
      row.mode ||
      'online';


    const selectedStatus =
      row.status ||
      'draft';


    const lifecycleLocked =
      [
        'completed',
        'cancelled'
      ].includes(
        selectedStatus
      );


    const types = [
      {
        value:'masterclass',
        symbol:'✦',
        title:'Masterclass',
        note:'Expert-led learning'
      },
      {
        value:'workshop',
        symbol:'✎',
        title:'Workshop',
        note:'Hands-on session'
      },
      {
        value:'ama',
        symbol:'?',
        title:'AMA',
        note:'Ask anything'
      },
      {
        value:'webinar',
        symbol:'◉',
        title:'Webinar',
        note:'Online learning'
      },
      {
        value:'panel',
        symbol:'•••',
        title:'Panel',
        note:'Multiple perspectives'
      },
      {
        value:'hackathon',
        symbol:'⌁',
        title:'Hackathon',
        note:'Build & compete'
      },
      {
        value:'meetup',
        symbol:'◎',
        title:'Meetup',
        note:'Meet your people'
      },
      {
        value:'college_event',
        symbol:'◇',
        title:'College Event',
        note:'Campus experience'
      },
      {
        value:'other',
        symbol:'+',
        title:'Other',
        note:'Create your own type'
      }
    ];


    const typeCards =
      types
        .map(
          type => `
            <button
              type="button"
              class="pn8ea-type-card ${
                selectedType ===
                type.value
                  ? 'is-selected'
                  : ''
              }"
              data-pn8ea-choice="event_type"
              data-value="${type.value}"
            >

              <span class="pn8ea-type-card__symbol">
                ${type.symbol}
              </span>

              <span>
                <strong>
                  ${type.title}
                </strong>

                <small>
                  ${type.note}
                </small>
              </span>

            </button>
          `
        )
        .join('');


    return `
      <form
        class="pn8ea-form pn8ea-builder"
        data-pn8ea-form
      >

        <input
          type="hidden"
          name="id"
          value="${escapeHTML(
            row.id ||
            ''
          )}"
        >

        <input
          type="hidden"
          name="event_type"
          value="${escapeHTML(
            selectedType
          )}"
        >

        <input
          type="hidden"
          name="mode"
          value="${escapeHTML(
            selectedMode
          )}"
        >

        <input
          type="hidden"
          name="status"
          value="${escapeHTML(
            selectedStatus
          )}"
        >


        <div class="pn8ea-builder-head">

          <div class="pn8ea-builder-head__icon">
            ✦
          </div>


          <div class="pn8ea-builder-head__copy">

            <small>
              PEERNEST EVENT BUILDER
            </small>

            <h2>
              ${
                editing
                  ? 'Edit your event'
                  : 'Create something students want to show up for.'
              }
            </h2>

            <p>
              ${
                editing
                  ? 'Update the experience, timing or publishing state.'
                  : 'Build the event once. PeerNest handles discovery, registration and the student experience.'
              }
            </p>

          </div>


          <button
            type="button"
            class="pn8ea-builder-close"
            data-pn8ea-close
            aria-label="Close event builder"
          >
            ×
          </button>

        </div>


        <div class="pn8ea-section">

          <div class="pn8ea-section-head">

            <span>01</span>

            <div>
              <h3>
                Start with the idea
              </h3>

              <p>
                Give the event a name and choose what kind of experience it is.
              </p>
            </div>

          </div>


          <div class="pn8ea-two">

            <label class="pn8ea-field">

              <span>
                Event title
                <b>*</b>
              </span>

              <input
                name="title"
                required
                value="${escapeHTML(
                  row.title ||
                  ''
                )}"
                placeholder="PeerNest Build Night"
              >

            </label>


            <label class="pn8ea-field">

              <span>
                Event slug
              </span>

              <input
                name="slug"
                value="${escapeHTML(
                  row.slug ||
                  ''
                )}"
                placeholder="We'll create this automatically"
              >

            </label>

          </div>


          <div class="pn8ea-field-block">

            <span class="pn8ea-field-label">
              What kind of event is this?
            </span>

            <div class="pn8ea-type-grid">
              ${typeCards}
            </div>


            <label
              class="pn8ea-field pn8ea-custom-type"
              data-pn8ea-custom-type-field
              ${
                selectedType === 'other'
                  ? ''
                  : 'hidden'
              }
            >

              <span>
                What should we call this event type?
                <b>*</b>
              </span>

              <input
                name="custom_event_type"
                maxlength="60"
                value="${escapeHTML(
                  row.custom_event_type ||
                  ''
                )}"
                placeholder="e.g. Founder Fireside, Case Competition, Design Jam..."
                ${
                  selectedType === 'other'
                    ? ''
                    : 'disabled'
                }
              >

              <small>
                This exact name will appear on the event card.
              </small>

            </label>

          </div>

        </div>


        <div class="pn8ea-section">

          <div class="pn8ea-section-head">

            <span>02</span>

            <div>
              <h3>
                When & where
              </h3>

              <p>
                Decide how students attend and when registration closes.
              </p>
            </div>

          </div>


          <div class="pn8ea-field-block">

            <span class="pn8ea-field-label">
              How will students attend?
            </span>


            <div class="pn8ea-mode-grid">

              <button
                type="button"
                class="pn8ea-mode-card ${
                  selectedMode ===
                  'online'
                    ? 'is-selected'
                    : ''
                }"
                data-pn8ea-choice="mode"
                data-value="online"
              >
                <span>◉</span>

                <strong>
                  Online
                </strong>

                <small>
                  Join using a live link
                </small>
              </button>


              <button
                type="button"
                class="pn8ea-mode-card ${
                  selectedMode ===
                  'offline'
                    ? 'is-selected'
                    : ''
                }"
                data-pn8ea-choice="mode"
                data-value="offline"
              >
                <span>⌂</span>

                <strong>
                  Offline
                </strong>

                <small>
                  Meet at a physical venue
                </small>
              </button>


              <button
                type="button"
                class="pn8ea-mode-card ${
                  selectedMode ===
                  'hybrid'
                    ? 'is-selected'
                    : ''
                }"
                data-pn8ea-choice="mode"
                data-value="hybrid"
              >
                <span>↔</span>

                <strong>
                  Hybrid
                </strong>

                <small>
                  Online + in person
                </small>
              </button>

            </div>

          </div>


          <div class="pn8ea-two">

            <label class="pn8ea-field">

              <span>
                Starts
                <b>*</b>
              </span>

              <input
                type="datetime-local"
                name="starts_at"
                required
                value="${escapeHTML(
                  localInputDate(
                    row.starts_at
                  )
                )}"
              >

            </label>


            <label class="pn8ea-field">

              <span>
                Ends
                <b>*</b>
              </span>

              <input
                type="datetime-local"
                name="ends_at"
                required
                value="${escapeHTML(
                  localInputDate(
                    row.ends_at
                  )
                )}"
              >

            </label>


            <label class="pn8ea-field">

              <span>
                Registration closes
              </span>

              <input
                type="datetime-local"
                name="registration_deadline"
                value="${escapeHTML(
                  localInputDate(
                    row.registration_deadline
                  )
                )}"
              >

            </label>


            <label class="pn8ea-field">

              <span>
                Capacity
              </span>

              <input
                type="number"
                min="1"
                name="capacity"
                value="${escapeHTML(
                  row.capacity ??
                  ''
                )}"
                placeholder="100"
              >

            </label>


            <label
              class="pn8ea-field"
              data-pn8ea-venue-field
            >

              <span>
                Venue
              </span>

              <input
                name="venue"
                value="${escapeHTML(
                  row.venue ||
                  ''
                )}"
                placeholder="PES University, Bengaluru"
              >

            </label>


            <label
              class="pn8ea-field"
              data-pn8ea-meeting-field
            >

              <span>
                Meeting link
              </span>

              <input
                type="url"
                name="meeting_url"
                value="${escapeHTML(
                  row.meeting_url ||
                  ''
                )}"
                placeholder="https://meet.google.com/..."
              >

              <small>
                Only registered students receive access.
              </small>

            </label>

          </div>

        </div>


        <div class="pn8ea-section">

          <div class="pn8ea-section-head">

            <span>03</span>

            <div>
              <h3>
                Give it a face
              </h3>

              <p>
                This is what students will see first while browsing events.
              </p>
            </div>

          </div>


          <div class="pn8ea-cover-wrap">

            <label class="pn8ea-upload">

              <input
                type="file"
                name="cover_image_file"
                accept="image/jpeg,image/png,image/webp"
              >

              <input
                type="hidden"
                name="cover_image_url"
                value="${escapeHTML(
                  row.cover_image_url ||
                  ''
                )}"
              >


              <div class="pn8ea-upload__preview">

                <img
                  src="${escapeHTML(
                    row.cover_image_url ||
                    ''
                  )}"
                  alt=""
                  data-pn8ea-cover-preview
                  ${
                    row.cover_image_url
                      ? ''
                      : 'hidden'
                  }
                >


                <div
                  class="pn8ea-upload__placeholder"
                  data-pn8ea-cover-placeholder
                  ${
                    row.cover_image_url
                      ? 'hidden'
                      : ''
                  }
                >

                  <span class="pn8ea-upload__art">
                    ▱
                  </span>

                  <strong>
                    Drop in your event cover
                  </strong>

                  <p>
                    JPG, PNG or WebP · up to 6 MB
                  </p>

                  <small>
                    Choose image
                  </small>

                </div>

              </div>

            </label>

          </div>

        </div>


        <div class="pn8ea-section">

          <div class="pn8ea-section-head">

            <span>04</span>

            <div>
              <h3>
                Tell students why they should care
              </h3>

              <p>
                Keep it useful, human and easy to scan.
              </p>
            </div>

          </div>


          <label class="pn8ea-field pn8ea-full">

            <span>
              Description
            </span>

            <textarea
              name="description"
              rows="4"
              placeholder="What will students get out of this event?"
            >${escapeHTML(
              row.description ||
              ''
            )}</textarea>

          </label>


          <label class="pn8ea-field pn8ea-full">

            <span>
              Agenda
            </span>

            <textarea
              name="agenda"
              rows="5"
              placeholder="6:00 PM — Welcome&#10;6:15 PM — Build session&#10;7:30 PM — Demos"
            >${escapeHTML(
              row.agenda ||
              ''
            )}</textarea>

          </label>

        </div>


        <div class="pn8ea-section pn8ea-section--final">

          <div class="pn8ea-section-head">

            <span>05</span>

            <div>
              <h3>
                Pricing & publishing
              </h3>

              <p>
                Decide whether students pay and whether this should go live.
              </p>
            </div>

          </div>



          <!-- PN_MANAGE_EVENTS_RICH_TEAM_V1 -->

          <div
            style="
              margin:22px 0;
              padding:20px;
              border:1px solid rgba(15,23,42,.10);
              border-radius:18px;
              background:rgba(255,255,255,.62);
            "
          >

            <div class="pn8ea-section-head">

              <span>
                ✦
              </span>

              <div>

                <h3>
                  Participation & event details
                </h3>

                <p>
                  Configure teams, eligibility, rewards,
                  stages and event information.
                </p>

              </div>

            </div>


            <div class="pn8ea-two">

              <label class="pn8ea-field">

                <span>
                  Organizer name
                </span>

                <input
                  name="organizer_name"
                  value="${escapeHTML(
                    row.organizer_name ||
                    ''
                  )}"
                  placeholder="PeerNest"
                >

              </label>


              <label class="pn8ea-field">

                <span>
                  Participation
                </span>

                <select
                  name="participation_type"
                  required
                >

                  <option
                    value="individual"
                    ${
                      (
                        row.participation_type ||
                        'individual'
                      ) === 'individual'
                        ? 'selected'
                        : ''
                    }
                  >
                    Individual
                  </option>

                  <option
                    value="team"
                    ${
                      row.participation_type ===
                        'team'
                        ? 'selected'
                        : ''
                    }
                  >
                    Team
                  </option>

                </select>

              </label>


              <label class="pn8ea-field">

                <span>
                  Fee model
                </span>

                <select name="fee_type">

                  <option
                    value="per_registration"
                    ${
                      (
                        row.fee_type ||
                        'per_registration'
                      ) ===
                      'per_registration'
                        ? 'selected'
                        : ''
                    }
                  >
                    Per registration
                  </option>

                  <option
                    value="per_team"
                    ${
                      row.fee_type ===
                        'per_team'
                        ? 'selected'
                        : ''
                    }
                  >
                    Per team
                  </option>

                  <option
                    value="per_member"
                    ${
                      row.fee_type ===
                        'per_member'
                        ? 'selected'
                        : ''
                    }
                  >
                    Per member
                  </option>

                </select>

              </label>


              <label class="pn8ea-field">

                <span>
                  Minimum team size
                </span>

                <input
                  type="number"
                  min="2"
                  name="team_size_min"
                  value="${escapeHTML(
                    row.team_size_min ??
                    ''
                  )}"
                  placeholder="2"
                >

              </label>


              <label class="pn8ea-field">

                <span>
                  Maximum team size
                </span>

                <input
                  type="number"
                  min="2"
                  name="team_size_max"
                  value="${escapeHTML(
                    row.team_size_max ??
                    ''
                  )}"
                  placeholder="4"
                >

              </label>

            </div>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Eligibility
              </span>

              <textarea
                name="eligibility"
                rows="3"
                placeholder="Who can participate?"
              >${escapeHTML(
                row.eligibility ||
                ''
              )}</textarea>

            </label>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Incentives & rewards
              </span>

              <textarea
                name="incentives"
                rows="5"
                placeholder="Winner | ₹10,000 | Cash prize + certificate&#10;Runner-up | ₹5,000 | Cash prize + certificate"
              >${escapeHTML(
                pnRichEventLinesValue(
                  row.incentives,
                  'incentives'
                )
              )}</textarea>

              <small>
                One per line:
                Title | Reward | Description
              </small>

            </label>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Stages & timeline
              </span>

              <textarea
                name="stages"
                rows="5"
                placeholder="Registration | Register before deadline&#10;Final Round | Present to jury"
              >${escapeHTML(
                pnRichEventLinesValue(
                  row.stages,
                  'stages'
                )
              )}</textarea>

              <small>
                One per line:
                Stage | Description
              </small>

            </label>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Rules & guidelines
              </span>

              <textarea
                name="rules"
                rows="5"
                placeholder="One rule per line"
              >${escapeHTML(
                pnRichEventLinesValue(
                  row.rules,
                  'rules'
                )
              )}</textarea>

            </label>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Certificate information
              </span>

              <textarea
                name="certificate_info"
                rows="3"
                placeholder="Participation / winner certificate details"
              >${escapeHTML(
                row.certificate_info ||
                ''
              )}</textarea>

            </label>


            <label
              class="pn8ea-field"
              style="margin-top:16px"
            >

              <span>
                Contact / support
              </span>

              <textarea
                name="contact_details"
                rows="3"
                placeholder="Email, phone or support details"
              >${escapeHTML(
                row.contact_details ||
                ''
              )}</textarea>

            </label>

          </div>


          <div class="pn8ea-price-row">

            <label class="pn8ea-paid">

              <input
                type="checkbox"
                name="is_paid"
                ${
                  row.is_paid === true
                    ? 'checked'
                    : ''
                }
              >

              <span class="pn8ea-paid__switch">
                <i></i>
              </span>


              <span class="pn8ea-paid__copy">

                <strong>
                  Paid Event
                </strong>

                <small>
                  Leave this off for free events.
                </small>

              </span>

            </label>


            <label class="pn8ea-field pn8ea-price-field">

              <span>
                Price per student
              </span>

              <div class="pn8ea-money">

                <span>
                  ₹
                </span>

                <input
                  type="number"
                  min="0"
                  step="0.01"
                  name="price"
                  value="${escapeHTML(
                    row.price ??
                    0
                  )}"
                >

              </div>

            </label>

          </div>


          ${
            lifecycleLocked
              ? `
                <div class="pn8ea-lifecycle-note">

                  <strong>
                    This event is currently ${escapeHTML(
                      selectedStatus
                    )}.
                  </strong>

                  <span>
                    Use Manage Events to change its lifecycle state.
                  </span>

                </div>
              `
              : `
                <div class="pn8ea-publish-grid">

                  <button
                    type="button"
                    class="pn8ea-publish-card ${
                      selectedStatus ===
                      'draft'
                        ? 'is-selected'
                        : ''
                    }"
                    data-pn8ea-choice="status"
                    data-value="draft"
                  >

                    <span>○</span>

                    <div>
                      <strong>
                        Save as Draft
                      </strong>

                      <small>
                        Only admins can see it.
                      </small>
                    </div>

                  </button>


                  <button
                    type="button"
                    class="pn8ea-publish-card ${
                      selectedStatus ===
                      'published'
                        ? 'is-selected'
                        : ''
                    }"
                    data-pn8ea-choice="status"
                    data-value="published"
                  >

                    <span>✦</span>

                    <div>
                      <strong>
                        Publish Event
                      </strong>

                      <small>
                        Students can discover and register immediately.
                      </small>
                    </div>

                  </button>

                </div>
              `
          }

        </div>


        <div class="pn8ea-builder-footer">

          <div>

            <span>
              ${
                editing
                  ? 'Editing existing event'
                  : 'Ready when you are.'
              }
            </span>

            <small>
              You can edit this later from Manage Events.
            </small>

          </div>


          <div class="pn8ea-builder-footer__actions">

            <button
              type="button"
              class="pn8ea-secondary"
              data-pn8ea-close
            >
              Cancel
            </button>

            <button
              type="submit"
              class="pn8ea-add"
            >
              ${
                editing
                  ? 'Save changes →'
                  : 'Create event →'
              }
            </button>

          </div>

        </div>

      </form>
    `;

  }



  async function openParticipants(
    eventId
  ) {

    const eventRow =
      adminRows.find(
        row =>
          row.id === eventId
      );


    if (!eventRow) {
      return;
    }


    const registrations =
      registrationsForEvent(
        eventId
      );


    const confirmed =
      registrations.filter(
        row =>
          [
            'reserved',
            'payment_pending',
            'confirmed',
            'attended'
          ].includes(
            row.status
          )
      );


    const cancelled =
      registrations.filter(
        row =>
          row.status ===
          'cancelled'
      );


    showModal(`
      <div class="pn8ea-participants">

        <div class="pn8ea-drawer-head">

          <div>

            <small>
              EVENT PARTICIPANTS
            </small>

            <h2>
              ${escapeHTML(
                eventRow.title
              )}
            </h2>

            <p>
              Loading registered students…
            </p>

          </div>

          <button
            type="button"
            data-pn8ea-close
          >
            ×
          </button>

        </div>

      </div>
    `);


    try {

      const ids =
        [
          ...new Set(
            registrations
              .map(
                row =>
                  row.user_id
              )
              .filter(Boolean)
          )
        ];


      let profiles =
        [];


      if (ids.length) {

        profiles =
          await request(
            'profiles',
            [
              'select=id,full_name,email,avatar_url',
              `id=in.(${ids
                .map(
                  id =>
                    `"${id}"`
                )
                .join(',')
              })`
            ].join('&')
          );

      }


      const profileMap =
        new Map(
          (
            Array.isArray(
              profiles
            )
              ? profiles
              : []
          )
            .map(
              profile => [
                profile.id,
                profile
              ]
            )
        );


      const content =
        modal?.querySelector(
          '[data-pn8ea-drawer-content]'
        );


      if (!content) {
        return;
      }


      const remaining =
        spotsLeft(
          eventRow
        );


      content.innerHTML = `
        <div class="pn8ea-participants">

          <div class="pn8ea-drawer-head">

            <div>

              <small>
                EVENT PARTICIPANTS
              </small>

              <h2>
                ${escapeHTML(
                  eventRow.title
                )}
              </h2>

              <p>
                Track registrations for this event without leaving the Events page.
              </p>

            </div>

            <button
              type="button"
              data-pn8ea-close
            >
              ×
            </button>

          </div>


          <div class="pn8ea-participant-stats">

            <div>
              <small>
                REGISTERED
              </small>

              <strong>
                ${confirmed.length}
              </strong>
            </div>


            <div>
              <small>
                CANCELLED
              </small>

              <strong>
                ${cancelled.length}
              </strong>
            </div>


            <div>
              <small>
                CAPACITY
              </small>

              <strong>
                ${
                  eventRow.capacity ??
                  '∞'
                }
              </strong>
            </div>


            <div>
              <small>
                SPOTS LEFT
              </small>

              <strong>
                ${
                  remaining === null
                    ? '∞'
                    : remaining
                }
              </strong>
            </div>

          </div>


          ${
            registrations.length
              ? `
                <div class="pn8ea-participant-table">

                  <table>

                    <thead>
                      <tr>
                        <th>Student</th>
                        <th>Status</th>
                        <th>Ticket</th>
                        <th>Registered</th>
                      </tr>
                    </thead>

                    <tbody>

                      ${registrations
                        .map(
                          registration => {

                            const profile =
                              profileMap.get(
                                registration.user_id
                              );


                            const initial =
                              String(
                                profile?.full_name ||
                                profile?.email ||
                                'S'
                              )
                                .charAt(0)
                                .toUpperCase();


                            return `
                              <tr>

                                <td>

                                  <div class="pn8ea-person">

                                    <div class="pn8ea-person__avatar">

                                      ${
                                        profile?.avatar_url
                                          ? `
                                            <img
                                              src="${escapeHTML(
                                                profile.avatar_url
                                              )}"
                                              alt=""
                                            >
                                          `
                                          : escapeHTML(
                                              initial
                                            )
                                      }

                                    </div>


                                    <div>

                                      <strong>
                                        ${escapeHTML(
                                          profile?.full_name ||
                                          'PeerNest Student'
                                        )}
                                      </strong>

                                      <small>
                                        ${escapeHTML(
                                          profile?.email ||
                                          registration.user_id
                                        )}
                                      </small>

                                    </div>

                                  </div>

                                </td>


                                <td>

                                  <span
                                    class="pn8ea-reg-status"
                                    data-status="${escapeHTML(
                                      registration.status
                                    )}"
                                  >
                                    ${escapeHTML(
                                      registration.status
                                    )}
                                  </span>

                                </td>


                                <td>
                                  ${escapeHTML(
                                    registration.ticket_code ||
                                    '—'
                                  )}
                                </td>


                                <td>
                                  ${escapeHTML(
                                    prettyDate(
                                      registration.created_at
                                    )
                                  )}
                                </td>

                              </tr>
                            `;

                          }
                        )
                        .join('')}

                    </tbody>

                  </table>

                </div>
              `
              : `
                <div class="pn8ea-empty pn8ea-empty--participants">

                  <span>
                    ◇
                  </span>

                  <strong>
                    No registrations yet.
                  </strong>

                  <p>
                    Students will appear here as soon as they register.
                  </p>

                </div>
              `
          }

        </div>
      `;

    }
    catch (error) {

      const content =
        modal?.querySelector(
          '[data-pn8ea-drawer-content]'
        );


      if (content) {

        content.innerHTML = `
          <div class="pn8ea-participants">

            <div class="pn8ea-drawer-head">

              <div>
                <small>
                  EVENT PARTICIPANTS
                </small>

                <h2>
                  ${escapeHTML(
                    eventRow.title
                  )}
                </h2>
              </div>

              <button
                type="button"
                data-pn8ea-close
              >
                ×
              </button>

            </div>


            <div class="pn8ea-empty">

              <strong>
                Registrations could not be loaded.
              </strong>

              <p>
                ${escapeHTML(
                  error?.message ||
                  'Please try again.'
                )}
              </p>

            </div>

          </div>
        `;

      }

    }

  }



  function openEditor(
    row = {}
  ) {

    showModal(
      editorForm(row)
    );


    const form =
      modal?.querySelector(
        '[data-pn8ea-form]'
      );


    hydrateEventForm(
      form
    );

  }


  async function changeStatus(
    id,
    status,
    button
  ) {

    button.disabled =
      true;


    try {

      await rpc(
        'pn8a_admin_set_event_status',
        {
          p_event_id:
            id,

          p_status:
            status
        }
      );


      await loadAdminEvents();


      openManager();


      /*
       * Reload the public event discovery layer so
       * publishing/drafting is immediately reflected.
       */
      window.setTimeout(
        () => {
          window.location.reload();
        },
        180
      );

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not update event status.'
      );


      button.disabled =
        false;

    }

  }


  async function saveEvent(form) {

    const submit =
      form.querySelector(
        '[type="submit"]'
      );


    submit.disabled =
      true;

    submit.textContent =
      'Saving…';


    try {

      const data =
        new FormData(
          form
        );


      const payload =
        Object.fromEntries(
          data.entries()
        );


      /* PN_MANAGE_EVENTS_RICH_TEAM_V1 */

      payload.participation_type =
        payload.participation_type ===
          'team'
          ? 'team'
          : 'individual';


      if (
        payload.participation_type ===
        'individual'
      ) {

        payload.fee_type =
          'per_registration';

        payload.team_size_min =
          null;

        payload.team_size_max =
          null;

      }
      else {

        payload.fee_type =
          [
            'per_team',
            'per_member'
          ].includes(
            payload.fee_type
          )
            ? payload.fee_type
            : 'per_team';


        const minTeam =
          Math.max(
            2,
            Number(
              payload.team_size_min ||
              2
            )
          );


        const maxTeam =
          Math.max(
            minTeam,
            Number(
              payload.team_size_max ||
              4
            )
          );


        payload.team_size_min =
          minTeam;

        payload.team_size_max =
          maxTeam;

      }


      payload.incentives =
        pnParseEventLines(
          payload.incentives,
          'incentives'
        );


      payload.stages =
        pnParseEventLines(
          payload.stages,
          'stages'
        );


      payload.rules =
        pnParseEventLines(
          payload.rules,
          'rules'
        );



      const coverFile =
        form.elements
          .cover_image_file
          ?.files?.[0];


      let coverURL =
        String(
          form.elements
            .cover_image_url
            ?.value ||
          ''
        );


      delete payload
        .cover_image_file;


      if (coverFile) {

        submit.textContent =
          'Uploading cover…';


        coverURL =
          await window.PeerNestDB
            .uploadEventCover(
              coverFile
            );

      }


      payload.cover_image_url =
        coverURL;


      payload.is_paid =
        form.elements
          .is_paid
          .checked;


      if (!payload.is_paid) {

        payload.price =
          0;

      }


      if (
        payload.mode ===
        'offline'
      ) {

        payload.meeting_url =
          '';

      }


      if (
        payload.mode ===
        'online'
      ) {

        payload.venue =
          '';

      }


      payload.starts_at =
        new Date(
          payload.starts_at
        ).toISOString();


      payload.ends_at =
        new Date(
          payload.ends_at
        ).toISOString();


      payload.registration_deadline =
        payload.registration_deadline
          ? new Date(
              payload.registration_deadline
            ).toISOString()
          : null;


      payload.timezone =
        'Asia/Kolkata';


      payload.currency =
        'INR';


      await rpc(
        'pn8a_admin_upsert_event_v2',
        {
          p_payload:
            payload
        }
      );


      await loadAdminEvents();


      closeModal();


      window.setTimeout(
        () => {
          window.location.reload();
        },
        180
      );

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not save event.'
      );


      submit.disabled =
        false;

      submit.textContent =
        'Save Event';

    }

  }


  function bindGlobalActions() {

    document.addEventListener(
      'click',
      async event => {

        const close =
          event.target.closest(
            '[data-pn8ea-close]'
          );


        if (close) {

          closeModal();
          return;

        }


        const add =
          event.target.closest(
            '[data-pn8ea-add-inside]'
          );


        if (add) {

          openEditor();
          return;

        }


        const participants =
          event.target.closest(
            '[data-pn8ea-participants]'
          );


        if (participants) {

          await openParticipants(
            participants.dataset
              .pn8eaParticipants
          );


          return;

        }


        const edit =
          event.target.closest(
            '[data-pn8ea-edit]'
          );


        if (edit) {

          const id =
            edit.dataset
              .pn8eaEdit;


          const row =
            adminRows.find(
              event =>
                event.id === id
            );


          if (row) {
            openEditor(row);
          }


          return;

        }


        const status =
          event.target.closest(
            '[data-pn8ea-status]'
          );


        if (status) {

          await changeStatus(
            status.dataset
              .pn8eaStatus,

            status.dataset
              .nextStatus,

            status
          );

        }

      }
    );


    document.addEventListener(
      'submit',
      event => {

        const form =
          event.target.closest(
            '[data-pn8ea-form]'
          );


        if (!form) {
          return;
        }


        event.preventDefault();

        saveEvent(form);

      }
    );

  }


  function syncMode() {

    if (!isAdminMode()) {

      if (ui) {
        ui.hidden = true;
      }


      closeModal();

      decorateCards();

      return;

    }


    ensureUI();


    if (ui) {
      ui.hidden = false;
    }


    loadAdminEvents();

  }


  function watchGrid() {

    if (
      !grid ||
      observer
    ) {
      return;
    }


    observer =
      new MutationObserver(
        () => {

          if (isAdminMode()) {
            decorateCards();
          }

        }
      );


    observer.observe(
      grid,
      {
        childList:true,
        subtree:true
      }
    );

  }


  function init() {

    bindGlobalActions();

    watchGrid();

    syncMode();


    document.addEventListener(
      'peernest:admin-view-changed',
      syncMode
    );


    /*
     * Admin Mode initializes independently.
     * These are harmless fallbacks in case its event
     * occurred just before this file executed.
     */

    window.setTimeout(
      syncMode,
      250
    );


    window.setTimeout(
      syncMode,
      900
    );

  }


  init();

})();
